var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    stroke: "current",
    width: "78.221886mm",
    height: "78.221886mm",
    viewBox: "0 0 78.221886 78.221886",
    id: "svg3108",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3105"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-51.202763,-72.621029)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      fillOpacity: 1,
      strokeWidth: 6.51007,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path42322",
    cx: 90.313705,
    cy: 111.73197,
    rx: 35.855999,
    ry: 35.855907
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 113.69315,132.7735 V 100.0422 L 90.313707,90.690439 66.934258,100.0422 v 32.7313 h 11.68968 v -21.04153 h 23.379532 v 21.04153 z m -25.717362,-4.67593 h -4.675925 v 4.67593 h 4.675925 z m 4.675837,-7.01384 h -4.675837 v 4.67592 h 4.675837 z m 4.675922,7.01384 h -4.675922 v 4.67593 h 4.675922 z",
    id: "path2",
    style: {
      strokeWidth: 0.264584
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.4aa4e9d4651df08deb1036c232180a2f.svg";
export { ForwardRef as ReactComponent };